module.exports = __webpack_public_path__ + "images/GSX-Dashboard.png";